// Runtime config. The theme (or demo shell) sets window.MCC_CONFIG before loading main.js:
//   window.MCC_CONFIG = {
//     apiBase: '/apps/mcc',            // App Proxy path (demo: local server; mock: '/mock-api')
//     cart: 'shopify' | 'demo',         // both use the Shopify Ajax Cart API paths
//     customer: { id, email } | null,  // logged-in customer from Liquid
//     routes: { ... }                   // optional URL templates (see DEFAULT_ROUTES)
//     privacyUrl, loginUrl, rulesUrl
//   }

const DEFAULT_ROUTES = {
  hub: '/collections/singles',
  builderDeck: '/collections/singles?build={id}',
  builderList: '/collections/singles?list={list}',
  builderCodes: '/collections/singles?c={codes}',
  cardSearch: '/collections/singles?q={q}',
  card: '/collections/singles?card={id}',
  product: '/products/{handle}',
  competitive: '/pages/competitive',
  archetype: '/pages/decks/{slug}',
  list: '/pages/deck-lists/{id}',
  explorer: '/pages/competitive-lists',
  requests: '/pages/my-requests',
  set: '/collections/{handle}',
  cart: '/cart',
  shopifySearch: '/search?q={q}&type=product',
  blog: '/blogs/news',
};

// The theme snippet passes base paths (decks: '/pages/decks', lists: '/pages/deck-lists', cartAdd: '/cart/add', ...);
// turn them into the templates used here. Explicit templates (containing '{') always win.
function mergeRoutes(r) {
  const out = Object.assign({}, DEFAULT_ROUTES);
  const base = (v) => String(v).replace(/\/$/, '');
  if (r.hub) { const h = base(r.hub); out.hub = h; out.builderDeck = h + '?build={id}'; out.builderList = h + '?list={list}'; out.builderCodes = h + '?c={codes}'; out.cardSearch = h + '?q={q}'; out.card = h + '?card={id}'; }
  if (r.decks) out.archetype = base(r.decks) + '/{slug}';
  if (r.lists) out.list = base(r.lists) + '/{id}';
  if (r.competitive) { out.competitive = base(r.competitive); out.explorer = base(r.competitive) + '-lists'; }
  if (r.explorer) out.explorer = r.explorer;
  ['requests', 'cart', 'blog'].forEach((k) => { if (r[k]) out[k] = r[k]; });
  if (r.search && !String(r.search).includes('{')) out.shopifySearch = base(r.search) + '?q={q}&type=product';
  if (r.login) out.login = r.login;
  // Ajax cart endpoints (locale-aware roots from Liquid routes.*)
  out.cartJs = (r.cart && /\/cart\/?$/.test(r.cart) ? base(r.cart) : '/cart') + '.js';
  out.cartAdd = (r.cartAdd ? base(r.cartAdd) : '/cart/add') + '.js';
  out.cartChange = (r.cartChange ? base(r.cartChange) : '/cart/change') + '.js';
  out.cartUpdate = (r.cartUpdate ? base(r.cartUpdate) : '/cart/update') + '.js';
  // explicit values for keys we own win (except 'search', which the theme uses for its own search URL)
  Object.keys(r).forEach((k) => { if ((k in DEFAULT_ROUTES && k !== 'search') || String(r[k]).includes('{')) out[k] = r[k]; });
  return out;
}

export function config() {
  const c = window.MCC_CONFIG || {};
  return {
    apiBase: (c.apiBase || '/apps/mcc').replace(/\/$/, ''),
    cart: c.cart || 'shopify',
    customer: c.customer && c.customer.id ? c.customer : null,
    routes: mergeRoutes(c.routes || {}),
    privacyUrl: c.privacyUrl || '/policies/privacy-policy',
    loginUrl: c.loginUrl || (c.routes && c.routes.login) || '/account/login',
    freeShippingThreshold: c.freeShippingThreshold || 130,
    rulesUrl: c.rulesUrl || '/pages/faq#reprints',
    // Back-in-stock emails (OD-5): off until a sender exists, so no copy promises an email.
    notify: c.notify === true,
    timeoutMs: c.timeoutMs || 8000,
    storeName: 'Monster Card Corner',
  };
}

// route('archetype', {slug:'dragapult-ex'}) -> '/pages/decks/dragapult-ex'
export function route(name, params) {
  const t = config().routes[name] || '/';
  return t.replace(/\{(\w+)\}/g, (m, k) => encodeURIComponent(params && params[k] != null ? params[k] : ''));
}
